import mm$1 from '@fes/mk-bridge-base';

/**
 * 指定动作  bridge
 **/
var action = {
    // 针对直播帧制定btn
    setLiveBtn: function (param, callback) {
        mm.build({
            common: ['action', 'setLiveBtn', param, callback],
            version: {sdk: '1.0', momo: {ios: '7.2.1', android: '7.2.1'}},
        });
    },
    // 获取地点
    getUserPlace: function (param, callback) {
        mm.build({
            common: ['action', 'getUserPlace', param, callback],
            version: {sdk: '1.0', momo: {ios: '7.2.1', android: '7.2.1'}},
        });
    },
    // 获取登陆状态
    getLoginStatus: function (callback) {
        mm.build({
            common: ['action', 'getLoginStatus', {}, callback],
            version: {sdk: '1.0', momo: {ios: '6.10', android: '6.10'}},
        });
    },
    /* 发布圈子帖子 */
    circlePublish: function (param, callback) {
        mm.build({
            common: ['action', 'circlePublish', param, callback],
            version: {sdk: '1.0', momo: {ios: '6.8', android: '6.8'}},
        });
    },
    // 评论页面键盘
    commentKeyboard: function (param, callback) {
        mm.build({
            common: ['action', 'commentKeyboard', param, callback],
            version: {sdk: '1.0', momo: {ios: '6.8', android: '6.8'}},
        });
    },
    // 设置聊天气泡
    setChatBubble: function (param, callback) {
        mm.build({
            common: ['action', 'setChatBubble', param, callback],
            version: {sdk: '1.0', momo: {ios: '6.0', android: '6.0'}},
        });
    },
    // 资料页封面
    setProfileCover: function (param, callback) {
        mm.build({
            common: ['action', 'setProfileCover', param, callback],
            version: {sdk: '1.0', momo: {ios: '6.0', android: '6.0'}},
        });
    },
    // 验证登陆
    verifyLogin: function (callback) {
        mm.build({
            common: ['action', 'verifyLogin', {}, callback],
            version: {sdk: '1.0', momo: {ios: '6.2', android: '6.2'}},
        });
    },
    // 刷新个人资料页
    refreshUserProfile: function (param, callback) {
        mm.build({
            common: ['action', 'refreshUserProfile', param, callback],
            version: {sdk: '1.0', momo: {ios: '6.3', android: '6.3'}},
        });
    },
    // 刷新群组资料页
    refreshGroupProfile: function (param, callback) {
        mm.build({
            common: ['action', 'refreshGroupProfile', param, callback],
            version: {sdk: '1.0', momo: {ios: '6.7', android: '6.7'}},
        });
    },
    // 检查通讯录
    checkContacts: function (param, callback) {
        if (typeof param.data == 'object') {
            param.data = JSON.stringify(param.data);
        }
        mm.build({
            common: ['action', 'checkContacts', param, callback],
            version: {sdk: '1.0', momo: {ios: '6.5', android: '6.5'}},
        });
    },
    // 获取最近聊天记录
    getChatList: function () {
        var callback, param;
        if (arguments.length === 1) {
            param = {count: 10};
            callback = arguments[0];
        } else {
            param = arguments[0];
            callback = arguments[1];
        }
        mm.build({
            common: ['action', 'getChatList', param, callback],
            version: {sdk: '1.0', momo: {ios: '6.5', android: '6.5'}},
        });
    },
    // 人脸识别
    doAuthenticate: function (param) {
        mm.build({
            common: ['action', 'doAuthenticate', param],
            version: {sdk: '1.0', momo: {ios: '8.1', android: '8.1'}},
        });
    },
    // 刷新礼物面板
    refreshGiftBoard: function (param, callback) {
        mm.build({
            common: ['action', 'refreshGiftBoard', param, callback],
            version: {sdk: '1.0', momo: {ios: '8.7.3', android: '8.7.3'}},
        });
    },

    getZhimaMetaInfo: function (callback) {
        mm.build({
            common: ['action', 'getZhimaMetaInfo', {}, callback],
            version: {sdk: '1.0'},

        });
    },
    gotoPage: function (param, callback) {
        if (mm.compare('7.0') < 0 && param.type === 'goto_select_all') {
            param.type = 'goto_select_contacts';
        }
        mm.build({
            common: ['action', 'gotoPage', param, callback],
            version: {sdk: '1.0'},
        });
    },

    analyzeRecord: function (param, callback) {
        mm.build({
            common: ['action', 'analyzeRecord', param, callback],
            version: {sdk: '1.0', momo: {ios: '8.18.7', android: '8.18.7'}}
        });
    },
    // 获取通知状态
    getBusinessNotifySwitch: function (param, callback) {
        mm.build({
            common: ['action', 'getBusinessNotifySwitch', param, callback],
            version: {sdk: '1.0', momo: {ios: '8.19.4', android: '8.19.4'}}

        });
    },
    //打开通知
    openBusinessNotifySwitch: function (param, callback) {
        mm.build({
            common: ['action', 'openBusinessNotifySwitch', param, callback],
            version: {sdk: '1.0', momo: {ios: '8.19.4', android: '8.19.4'}}

        });
    },
    //关闭通知
    closeBusinessNotifySwitch: function (param, callback) {
        mm.build({
            common: ['action', 'closeBusinessNotifySwitch', param, callback],
            version: {sdk: '1.0', momo: {ios: '8.19.4', android: '8.19.4'}},

        });
    },
    //通知扫描相册
    startScanPhotosPoi: function(param) {
        mm.build({
            common: ['action', 'startScanPhotosPoi', param],
            need_mk: true
        });
    }
};

/**
 * 应用  bridge
 **/

function initAppObj(param) {
    if (!param.hasOwnProperty('apps')) return;
    var type = mm.is_mk ? 'apps' : 'games';
    var pre = param.apps;
    var endObj = {};
    endObj[type] = {};
    for (var k in pre) {
        var _url = "url_" + mm.platform;
        endObj[type][k] = {
            schema: pre[k].schema,
            url: pre[k][_url] || '',
            param: pre[k].param || {}
        };
    }
    return endObj;
}

var app = {
    // 添加app下载，到下载器 仅安卓
    downloadApp: function (param, callback) {
        mm.build({
            android: ['app', 'downloadApp', param, callback],
            version: {sdk: '1.0', momo: {android: '8.1' }},
        });
    },
    // 获取下载列表，仅安卓
    getDownloadList: function (callback) {
        mm.build({
            android: ['app', 'getDownloadList', {}, callback],
            version: {sdk: '1.0', momo: {android: '8.1' }},
        });
    },
    // 检查app是否已安装
    isInstalled: function (param, callback) {
        /* 最终格式：
         apps: {
         'ex_hero_X8dFahX': {
         schema: 'http://itunes.apple.com/cn/app/?id=859037264&ls=1&mt=8',
         url:''
         },
         'ex_bydz_9sH6dXG': {
         schema: 'http://itunes.apple.com/cn/app/?id=860491710&ls=1&mt=8',
         url:''
         }
         }
         */
        var endParam = initAppObj(param);
        mm.build({
            common: ['app', 'isInstalled', endParam, callback]
        });
    },
    // 安装app
    installApps: function (param, callback) {
        /* 最终格式：
         apps: {
         'ex_hero_X8dFahX': {
         schema: 'http://itunes.apple.com/cn/app/?id=859037264&ls=1&mt=8',
         url:  'http://itunes.apple.com/cn/app/?id=859037264&ls=1&mt=8'  //url区分平台
         },
         'ex_bydz_9sH6dXG': {
         schema: 'http://itunes.apple.com/cn/app/?id=860491710&ls=1&mt=8',
         url: 'http://itunes.apple.com/cn/app/?id=860491710&ls=1&mt=8',

         }
         }
         */
        var endParam = initAppObj(param);
        mm.build({
            common: ['app', 'installApps', endParam, callback]
        });
    },
    // 唤起第三方应用
    launchApp: function (param) {
        mm.build({
            common: ['app', 'launchApp', {
                schema: param.schema,
                url: param['url_' + mm.platform] || ''
            }]
        });
    }
};

/**
 *  @file 支付bridge
 * */
var pay = {
  /* 收银台 */
  cashDesk: function(param, callback) {
    mm.build({
      common: ['pay', 'cashDesk', param, callback],
      version: {sdk: '1.0', momo: {ios: '6.11.3', android: '7.0'}},
    });
  },
  cashKey: function(param, callback) {
    mm.build({
      common: ['pay', 'cashKey', param, callback],
      version: {sdk: '1.0', momo: {ios: '6.11.3', android: '7.0'}},
    });
  },
  doAlipay: function(param, callback) {
    mm.build({
      common: ['pay', 'doAlipay', param, callback],
      version: {sdk: '1.0', momo: '6.1'},

    });
  },
  bindAlipay: function(param, callback) {
    mm.build({
      common: ['pay', 'bindAlipay', param, callback],
      version: {sdk: '1.0', momo: {ios: '6.11.3', android: '7.0'}},
    });
  },
  doWXpay: function(param, callback) {
    mm.build({
      common: ['pay', 'doWXpay', param, callback],
      version: {sdk: '1.0', momo: {ios: '6.8', android: '6.8'}},
    });
  },
  sendPayResult: function(param) {
    mm.build({
      common: ['pay', 'sendPayResult', param],
      version: {sdk: '1.0', momo: {ios: '6.10', android: '6.10'}},
    });
  },
  doWXwithhold: function(param) {
    mm.build({
      common: ['pay', 'doWXwithhold', param],
      version: {sdk: '1.0', momo: {ios: '7.7', android: '7.7'}},
    });
  },
  doAliwithhold: function(param) {
    mm.build({
      common: ['pay', 'doAliwithhold', param],
      version: {sdk: '1.0', momo: {ios: '7.7', android: '7.7'}},
    });
  },
};

/**
 * @file 传感器 bridge
 **/

var sensor = {
  // 取得当前位置信息
  getLocation: function(callback) {
    var newCallback = function(resp) {
      if (mm.platform === 'ios') {
        resp.latitude = resp.lat;
        resp.longitude = resp.lng;
        delete resp.lat;
        delete resp.lng;
      }
      callback.call(null, resp);
    };
    mm.build({
      common: ['sensor', 'getLocation', {}, newCallback],
      version: {sdk: '1.0', momo: '6.0'},

    });
  },
  openLocation: function(param, callback) {
    mm.build({
      common: ['sensor', 'openLocation', param, callback],
      version: {sdk: '1.0', momo: '6.0'},

    });
  },
  // 浏览内置地图位置
  viewLocation: function(param) {
    mm.build({
      common: ['sensor', 'viewLocation', param],
      version: {sdk: '1.0', momo: '6.0'},

    });
  },

  vibrate: function(param) {
    mm.build({
      common: ['sensor', 'vibrate', param],
      version: {sdk: '1.0', momo: '6.6'},
    });
  },
};

// 分享
var share = {
    showSharePanel: function(param, callback) {
        if (typeof callback == 'undefined') {
            callback = function() {};
        }
        mm.build({
            common: ['share', 'showSharePanel', param, callback],
        });
    },
    showPanel: function (param, callback) {
        if (typeof callback == 'undefined') {
            callback = function () {
            };
        }
        if (param) {
            var projectArr = ['title', 'text', 'url', 'pic'];
            var configs = param.configs;

            if (configs) {
                /*
                    分享到动态，如果没有参数sdk：
                    1. 如果有大图，默认走服务器下发 sdk=0
                    2. 如果没有大图，默认走sdk分享 sdk=1，分享的默认文字为参数sdk_text
                */

                if (configs.momo_feed) {
                    var feed = configs.momo_feed;

                    if (typeof feed.sdk == 'undefined' && !feed.pic && feed.resource) {
                        feed.sdk = 1;
                    }
                }

                for (var k in configs) {
                    projectArr.forEach(function (pro) {
                        if (!configs[k].hasOwnProperty(pro) && param[pro]) {
                            configs[k][pro] = param[pro];
                        }
                    });
                }
                if (configs.momo_contacts) {
                    !configs.momo_friend && (configs.momo_friend = configs.momo_contacts);
                    !configs.momo_discuss && (configs.momo_discuss = configs.momo_contacts);
                    !configs.momo_group && (configs.momo_group = configs.momo_contacts);
                }
            }
        }

        mm.build({
            common: ['share', 'showPanel', param, callback],
        });
    },
    toApp: function (param, callback) {
        if (param.app == 'momo_feed') {
            /*
                分享到动态，如果没有参数sdk：
                1. 如果有大图，默认走服务器下发 sdk=0
                2. 如果没有大图，默认走sdk分享 sdk=1，分享的默认文字为参数sdk_text
            */

            if (typeof param.sdk == 'undefined' && !param.pic && param.resource) {
                param.sdk = 1;
            }
        }
        mm.build({
            common: ['share', 'toApp', param, callback],
        });
    },
    // showPanel: function (param, callback) {
    //     mm.build({
    //         common: ['ui', 'showPanel', param, callback]
    //     })
    // },
    shareToIMWithParams:function (param, callback) {
        mm.build({
            common: ['share', 'shareToIMWithParams', param, callback],
        });
    }
};

/**
 *  websocket bridge
 **/
var websocket = {
    //建立连接
    connect: function (param, callback) {
        mm.build({
            common: ['websocket', 'connect', param, callback],
            version: {sdk: '1.0', momo: {ios: '8.11.3', android: '8.11.3'}},
        });
    },
    //断开连接
    disconnect: function (param, callback) {
        mm.build({
            common: ['websocket', 'disconnect', param, callback],
            version: {sdk: '1.0', momo: {ios: '8.11.3', android: '8.11.3'}},
        });
    },
    //发送请求
    send: function (param, callback) {
        mm.build({
            common: ['websocket', 'send', param, callback],
            version: {sdk: '1.0', momo: {ios: '8.11.3', android: '8.11.3'}},
        });
    }
};

mm$1.action = action;
mm$1.app = app;
mm$1.pay = pay;
mm$1.sensor = sensor;
mm$1.share = share;
mm$1.websocket = websocket;

export default mm$1;
